import { BusMarkerIcon } from './BusMarkerIcon';

/**
 * author: Michael Richins
 * id 42DCF950-C2F2-4989-8E0B-ACF16326A6A7
 * name bus-marker
 * version: 4.6.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/bus-marker.svg
 * tags
 * - Navigation 
 */
export const BusLocationIcon = BusMarkerIcon;
export default BusLocationIcon